'use client';
import { oneHub } from '@/types/oneHub';
import { Divider, Image } from '@nextui-org/react';
import { Libre_Baskerville } from 'next/font/google';
import { useEffect, useState } from 'react';
const inter = Libre_Baskerville({ weight: '400', style: 'italic', subsets: ['latin'] });

interface IExpendProps {
  list: oneHub.ICases[] | oneHub.ICritical[];
  type: 'example' | 'critical';
}

export default function MobileExpend(props: IExpendProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(true);
  }, []);
  const { type } = props;
  return (
    <div>
      <div className="flex items-center w-full cursor-pointer pt-[10px]" onClick={() => setIsOpen(!isOpen)}>
        <Image
          src={type === 'example' ? '/example.png' : '/critical-thinking.png'}
          radius="none"
          width={30}
          height={30}
          alt="example"
        />
        {
          show ?
          <span className={`${inter.className} text-[16px] leading-[20px] pl-[6px] flex-1 text-left`}>{type === 'example' ? 'Example' : 'Critical Thinking'}</span>
            : null
        }
        <Image
          alt='expend'
          src='/expend.png'
          width={20}
          height={20}
          radius='none'
        />
      </div>
      <div className={`${isOpen ? 'block' : 'hidden'}`}>
        {
          props.list.map((item, index) => {
            return (
              <div key={index} className="text-[16px] leading-[28px]">
                <p className="pt-3">
                  <span className="font-semibold">Key Point:</span>
                  <span> {item.point}</span>
                </p>
                <p className="pt-3">
                  <span className="font-semibold">
                    {
                      type === 'example' ? 'Example:' : 'Critical Interpretation:'
                    }
                  </span>
                  <span> {item.desc}</span>
                </p>
              </div>
            );
          })
        }
      </div>
      <Divider className="mt-[10px]" />
    </div>
  );
}
